import validate from "/workspace/Optilink/management-tool-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  "is-authenticated": () => import("/workspace/Optilink/management-tool-frontend/middleware/isAuthenticated.ts")
}